import moment from "moment";
import { Cell } from "react-table";
import { NoticeModel } from "src/api/notice/notice-types";
import { BaseTooltip } from "src/components";
import DetailLink from "src/components/DetailLink";
import PagePath from "src/pagePath.json";
import { ViewYmdFormat } from "src/utils";
import { noticeCategoryToText } from "../../notice-types";
/*
  공지사항 목록 columns
*/
const noticeColumns = [
  {
    Header: "공지사항 ID",
    accessor: "id",
    width: 120,
    Cell: ({ value }: Cell<NoticeModel>) => {
      const detailPath = `${PagePath.notice.detail.replace(":id", `${value}`)}`;
      return (
        <div>
          <DetailLink className="text-underline" to={`${detailPath}`}>
            {value}
          </DetailLink>
        </div>
      );
    },
  },
  {
    Header: () => {
      return <span className="no-wrap">공개여부</span>;
    },
    accessor: "isDisplayed",
    width: 80,
    align: "center",
    Cell: (props: Cell<NoticeModel>) => {
      return <div>{props.value ? <div className="status B">공개</div> : <div className="status D">비공개</div>}</div>;
    },
  },
  {
    Header: "카테고리",
    accessor: "noticeCategory",
    width: 80,
    align: "center",
    Cell: ({ value }: Cell<NoticeModel>) => {
      return <p>{noticeCategoryToText(value)}</p>;
    },
  },
  {
    // 상세 페이지 이동 제거 (진입은 공지사항 ID 컬럼으로 일원화)
    Header: "제목",
    accessor: "title",
    width: 250,
    Cell: (props: Cell<NoticeModel>) => {
      return <div className="w-100 text-left ellipsis">{props.value ? props.value : "-"}</div>;
    },
  },
  {
    // 기존 '공개기간' 단일 컬럼을 시작/종료로 분리. ISO 8601 표준(YYYY-MM-DD HH:mm:ss)
    Header: "공개시작일시",
    accessor: "displayStartDate",
    width: 160,
    align: "center",
    Cell: ({ value }: Cell<NoticeModel>) => <span>{value ? moment(value).format(ViewYmdFormat.FULL) : "-"}</span>,
  },
  {
    Header: "공개종료일시",
    accessor: "displayEndDate",
    width: 160,
    align: "center",
    Cell: ({ value }: Cell<NoticeModel>) => <span>{value ? moment(value).format(ViewYmdFormat.FULL) : "-"}</span>,
  },
  {
    Header: "적용 건물",
    accessor: "buildingNames",
    width: 200,
    Cell: (props: Cell<NoticeModel>) => {
      return <>
        <BaseTooltip contents={props.value && props.value.length > 0 ? props.value.join(", ") : "-"} />
      </>;
    },
  },
  {
    // 두줄 말줄임 처리되는 경우 호버로 전체 계약명 확인
    Header: "적용 계약",
    accessor: "contractProductNames",
    width: 120,
    Cell: (props: Cell<NoticeModel>) => {
      return <BaseTooltip className="text-left w-100" contents={props.value && props.value.length > 0 ? props.value.join(", ") : "-"} />;
    },
  },
  {
    Header: "최종 수정일시",
    accessor: "lastModifiedDate",
    width: 160,
    align: "center",
    // ISO 8601 표준(YYYY-MM-DD HH:mm:ss), 당일 여부와 관계없이 날짜+시간 항상 노출 (호버 제거)
    Cell: ({ value }: Cell<NoticeModel>) => <span>{value ? moment(value).format(ViewYmdFormat.FULL) : "-"}</span>,
  },
];

export default noticeColumns;
